import { IAppEntity } from "src/config/entities";
import React from "react";
import { ReferenceTypes } from "src/enums/ReferenceTypes";
import { ImportsDetail } from "src/components/Pages/Documents/Imports/components/ImportsDetail";
import { NFLookupImports } from "src/components/Shared/NewForms/NFLookupImports";
import { ICreateImportDto } from "src/components/Pages/Documents/Imports/dtos/ICreateImportsDto";
import { ImportsService } from "src/services/documents/ImportsService";
import {ImportsList } from 'src/components/Pages/Documents/Imports/components/ImportsList'

export const Imports: IAppEntity = {
  entityType: "document",
  title: "Imports",
  pluralTitle: "Imports",
  apiUrl: "Imports",
  apiEnum: ReferenceTypes.DocumentImport,
  getDetailView: (id?: string) => {
    return React.createElement(ImportsDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ImportsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),

  getLookupComponent(model: any): any {
    return React.createElement(NFLookupImports, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new ImportsService("Imports"),
  getEmptyModel: () => {
    const model: ICreateImportDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      documentDate: new Date(),
      comment: "",
      // vats: []
    };
    return model;
  }
};

// import { ICreateImportsDto } from "src/components/Pages/Documents/Imports/dtos/ICreateImportsDto";
// import { ImportsService } from "./../../../services/documents/ImportsService";
// import { ImportsDetail } from "../../../components/Pages/Documents/Imports/components/ImportsDetail";
// import { IAppEntity } from "../../entities";
// import React from "react";
// import { ReferenceTypes } from "../../../enums/ReferenceTypes";
// import { NFLookupImports } from "../../../components/Shared/NewForms/NFLookupImports";
// import ImportsList from '../../../components/Pages/Documents/Imports/components/ImportsList'

// export const Imports: IAppEntity = {
//   entityType: "document",
//   title: "Imports",
//   pluralTitle: "Imports",
//   apiUrl: "Imports",
//   apiEnum: ReferenceTypes.DocumentPostingOfGood,
//   getDetailViewComponent: (
//     model: any,
//     modelUpdatedEvent: (model: any) => void
//   ) =>
//     React.createElement(ImportsDetail, {
//       model: model,
//       modelUpdatedEvent: modelUpdatedEvent,
//     }),
//   getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
//     React.createElement(ImportsList, {
//       model: model,
//       modelUpdatedEvent: modelUpdatedEvent,
//     }),
//   getLookupComponent(model: any): any {
//     return React.createElement(NFLookupImports, {
//       fieldName: model.fieldName,
//       title: model.title,
//       setSelectedCatalog: model.setSelectedCatalog,
//     });
//   },
//   getDataService: () => new ImportsService("Imports"),
//   getEmptyModel: () => {
//     const model: ICreateImportsDto = {
//       totalAmount: 0,
//       totalAmountVat: 0,
//       status: 0,

//       documentDate: new Date(),
//       comment: "",
//       vats: [],
//     };
//     return model;
//   },
// };

